import { render, staticRenderFns } from "./InterfacePositionWishNew.vue?vue&type=template&id=41e53485"
import script from "./InterfacePositionWishNew.vue?vue&type=script&lang=js"
export * from "./InterfacePositionWishNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports